import React from "react";
import { Link } from "react-router-dom";
import { useMutation, useQueryCache } from "react-query";

import {
    MainContainer,
    TitleContainer,
    MainTitle,
    MainForm,
    MainFormContent,
    TextInput,
    TextAreaInput,
    ButtonsRow,
    MainButton,
    Divider,
    SectionTitle,
    RateInput
} from "@beacharound/beacharound-ui";

import { createBeach } from "../../../api/beach";

const constraints = {
    title: { presence: true },
    subtitle: { presence: true },
    cover: { presence: true },
    description: { presence: true }
}

export default function Create({ match, history }) {

    const cache = useQueryCache();
    
    const [create, { status }] = useMutation(createBeach, {
            onSuccess: (data) => {
                cache.invalidateQueries("beaches")
                cache.setQueryData(["beaches", data._id], data)
                return history.push(match.url.replace("create", data?._id))
            }
        }
    )

    function save(data) {
        return create({ data })
    }

    return (
        <MainContainer marginBottom>
            <TitleContainer>
                <MainTitle text="Nuova recensione" />
            </TitleContainer>

            <MainForm onSubmit={save} constraints={constraints}>
                <TitleContainer>
                    <SectionTitle text="Dettagli recensione" />
                </TitleContainer>
                <MainFormContent flex>
                    <TextInput
                        label="Titolo"
                        name="title"
                    />
                    <RateInput
                        label="Valutazione"
                        name="rating"
                    />
                    <TextAreaInput
                        label="Descrizione"
                        name="description"
                    />
                </MainFormContent>

                <Divider />

                <ButtonsRow fill marginBottom>
                    <MainButton
                        text="Annulla"
                        border
                        component={Link}
                        to={`/costumerCare/reviews`}
                    />
                    <MainButton text="Crea recensione" submit status={status} />
                </ButtonsRow>
            </MainForm>
        </MainContainer>
    );
}
